import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingBoxBase, SettingBoxPositionTable } from '../../../app/components/settings-drawer';
import {
    useLiquidityCashWithOtherBanksSettings,
    useUpdateLiquidityCashWithOtherBanksItemSettings,
    useUpdateLiquidityCashWithOtherBanksPanelSettings,
} from '../../api';
import { useLiquidityScopeUpdating, useLiquiditySelectedBankableAssets } from '../../hooks';

interface IProps {
    expandedKey?: string;
}

export const LiquidityCashWithOtherBanksSettings: FunctionComponent<IProps> = ({ expandedKey }) => {
    const { t } = useTranslation();
    const totalSelectedBankableAssets = useLiquiditySelectedBankableAssets();
    const { data: cashWithOtherBanksSettings, isFetching } = useLiquidityCashWithOtherBanksSettings();
    const isScopeUpdating = useLiquidityScopeUpdating();

    const updateCashWithOtherBanksSettings = useUpdateLiquidityCashWithOtherBanksPanelSettings();
    const updateCashWithOtherBanksItemSettings = useUpdateLiquidityCashWithOtherBanksItemSettings();

    return (
        <SettingBoxBase
            title={t('liquidityCalculatorSettings.cashWithOtherBanks')}
            showWarningIcon={totalSelectedBankableAssets <= 0}
            warningText={t('noBankableAssetsWarning')}
            boxId={cashWithOtherBanksSettings?.id}
            sectionKey="cashWithOtherBanks"
            expandedKey={expandedKey}
            toggled={cashWithOtherBanksSettings?.enabled}
            onToggle={updateCashWithOtherBanksSettings}
            detail={
                <SettingBoxPositionTable
                    enabled={!!cashWithOtherBanksSettings?.enabled}
                    updateItemSettings={updateCashWithOtherBanksItemSettings}
                    itemSettings={cashWithOtherBanksSettings?.itemsSettings ?? []}
                    totalAmount={cashWithOtherBanksSettings?.totalAmount ?? 0}
                    emptyStateMessage={t('liquidityCalculatorSettings.emptyCashWithOtherBanks')}
                    emptyStateShowWealthLink={true}
                    isUpdating={isFetching || isScopeUpdating}
                />
            }
        />
    );
};
